import { Chip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Small badge shown next to a translatable field whose human-authored translation is out of sync
 * because the source (primary-language) text changed after it was written.
 */
const StaleTranslationBadge: React.FC = () => {
	const { t } = useTranslation();

	return (
		<Chip
			label={t("translations.staleBadge")}
			color="warning"
			size="small"
			variant="outlined"
		/>
	);
};

export default StaleTranslationBadge;
